"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Target = void 0;
const Faction_1 = require("./enums/Faction");
const TargetType_1 = require("./enums/TargetType");
class Target {
    constructor(type, actorIds) {
        this.type = type;
        this.actorIds = actorIds;
    }
}
exports.Target = Target;
Target.None = new Target(TargetType_1.TargetType.None, []);
Target.Self = new Target(TargetType_1.TargetType.Self, []);
Target.OneOfSameFaction = (faction, selectedId) => {
    switch (faction) {
        case Faction_1.Faction.Ally:
            return Target.OneAlly(selectedId);
        case Faction_1.Faction.Enemy:
            return Target.OneEnemy(selectedId);
        default:
            throw new Error(`cannot select targets of faction ${Faction_1.Faction[faction]}`);
    }
};
Target.All = new Target(TargetType_1.TargetType.All, []);
Target.AllAllies = new Target(TargetType_1.TargetType.AllAllies, []);
Target.OneAlly = (allyId) => new Target(TargetType_1.TargetType.OneAllies, [allyId]);
Target.AllCompanions = new Target(TargetType_1.TargetType.AllCompanions, []);
Target.OneCompanion = (companionId) => new Target(TargetType_1.TargetType.OneCompanion, [companionId]);
Target.AllAllyCompanions = new Target(TargetType_1.TargetType.AllCompanions, []);
Target.AllEnemyCompanions = new Target(TargetType_1.TargetType.AllCompanions, []);
Target.AllEnemies = new Target(TargetType_1.TargetType.AllEnemies, []);
Target.OneEnemy = (enemyId) => new Target(TargetType_1.TargetType.OneEnemies, [enemyId]);
Target.Any = (ids) => new Target(TargetType_1.TargetType.Any, ids);
Target.LastAttackedBy = new Target(TargetType_1.TargetType.LastAttackedBy, []);
